<template>
  <v-dialog
    v-model="selectDialog"
    v-bind="$attrs"
    :scrollable="$vuetify.breakpoint.smAndDown"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :width="$vuetify.breakpoint.mdAndDown ? '70%' : '40%'"
    @keydown.esc="cancelAction"
  >
    <!-- <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->

    <!-- <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        type="article, actions"
      ></v-skeleton-loader>
    </div> -->
    <v-card>
      <v-card-title>
        <span class="h4">Tipo de Item a Ser Criado</span>
        <v-spacer></v-spacer>
          <v-btn
            text
            icon
            title="Cancelar"
            class="my-2"
            @click="cancelAction"
          >
            <v-icon right dark>mdi-close-circle</v-icon>
          </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <!-- <v-alert
          type="error"
          elevation="2"
          v-if="formErrors.length > 0"
          dismissible
        >
          <p v-for="error in formErrors" class="mb-0">
            {{error}}
          </p>
        </v-alert> -->

        <v-list
          :flat="false"
          :dense="false"
          class="mt-5"
        >
          <v-list-item-group
            :multiple="false"
            :mandatory="true"
            color="success"
          >
            <v-divider
              key="divider-1"
            />
            <v-list-item
              key="list-item-1"
              @click="partOpenAction"
              :two-line="false"
            >
              <v-list-item-icon>
                <v-icon>mdi-bolt</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="title">Peça</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <PartNew
              ref="partNew"
              :usesOpenButtonSlot="true"
              @entry-created="partCreated"
            >
              <template v-slot:open_button="dialog">
                <a v-on="{ ...dialog }" @click="emitOpenActionPartNew">
                  <v-list-item
                      :two-line="false"
                      class="mb-2"
                    >
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="title">Peça</span>
                        < !-- <br> 
                        <span class="text--disabled ml-2">Tipo peças</span> -- >
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </a>
              </template>
            </PartNew> -->

            <v-divider
              key="divider-2"
            />
            <v-list-item
              key="list-item-2"
              @click="oilOpenAction"
              :two-line="false"
            >
              <v-list-item-icon>
                <v-icon>mdi-water</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="title">Óleo/Combustível</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <OilNew
              ref="oilNew"
              :usesOpenButtonSlot="true"
              @entry-created="oilCreated"
            >
              <template v-slot:open_button="dialog">
                <a v-on="{ ...dialog }" @click="emitOpenActionOilNew">
                  <v-list-item
                      :two-line="false"
                      class="mb-2"
                    >
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="title">Óleo/combustível</span>
                        < !-- <br> 
                        <span class="text--disabled ml-2">Tipo peças</span> -- >
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </a>
              </template>
            </OilNew> -->

            <v-divider
              key="divider-3"
            />

            <v-list-item
              key="list-item-3"
              @click="otherOpenAction"
              :two-line="false"
            >
              <v-list-item-icon>
                <v-icon>mdi-asterisk</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="title">Item Diverso</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <!-- <v-divider
              key="divider-4"
            />

            <v-list-item
              key="list-item-4"
              @click="agrotoxicOpenAction"
              :two-line="false"
            >
              <v-list-item-icon>
                <v-icon>mdi-flask</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="title">Agrotóxico</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-divider
              key="divider-5"
            />

            <v-list-item
              key="list-item-5"
              @click="fertilizerOpenAction"
              :two-line="false"
            >
              <v-list-item-icon>
                <v-icon>mdi-flask-round-bottom</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="title">Fertilizante</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-divider
              key="divider-6"
            />

            <v-list-item
              key="list-item-6"
              @click="biologicOpenAction"
              :two-line="false"
            >
              <v-list-item-icon>
                <v-icon>mdi-flask-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="title">Biológico</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            
            <v-divider
              key="divider-last"
            />
            
            <!-- <OtherNew
              ref="otherNew"
              :usesOpenButtonSlot="true"
              @entry-created="otherCreated"
            >
              <template v-slot:open_button="dialog">
                <a v-on="{ ...dialog }" @click="emitOpenActionOtherNew">
                  <v-list-item
                      :two-line="false"
                      class="mb-2"
                    >
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="title">Item Diverso</span>
                        < !-- <br> 
                        <span class="text--disabled ml-2">Tipo peças</span> -- >
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </a>
              </template>
            </OtherNew> -->

            <a class="title ml-3" style="text-decoration: none;" target="_blank" href="https://wa.me/5551980629669?text=Ol%C3%A1%2C%20Suporte%20T%C3%A9cnico.%20Gostaria%20de%20cadastrar%20um%20novo%20item%20na%20plataforma%20AgroSim.%20Poderia%20me%20ajudar%3F">          
              <v-list-item
                  :two-line="true"
                >
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="title">Semente, Muda, Fertilizante, Biológico ou Agrotóxico</span>
                    <br> 
                    <v-icon color="green">mdi-whatsapp</v-icon>
                    <span class="text--disabled ml-2">Contatar o suporte AgroSim via WhatsApp</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </a>

          </v-list-item-group>

        </v-list>

        <PartNew
          ref="partNew"
          @entry-created="partCreated"
          modelNameSingular="Peça"
          :useModelInsteadOfButton="true"
        />

        <OilNew
          ref="oilNew"
          @entry-created="oilCreated"
          modelNameSingular="Óleo/Combustível"
          :useModelInsteadOfButton="true"
        />

        <OtherNew
          ref="otherNew"
          @entry-created="otherCreated"
          modelNameSingular="Item Diverso"
          :useModelInsteadOfButton="true"
        />

        <!-- <AgrotoxicNew
          ref="agrotoxicNew"
          @entry-created="agrotoxicCreated"
          modelNameSingular="Agrotoxic"
          :useModelInsteadOfButton="true"
        />

        <FertilizerNew
          ref="fertilizerNew"
          @entry-created="fertilizerCreated"
          modelNameSingular="Fertilizante"
          :useModelInsteadOfButton="true"
        />


        <BiologicNew
          ref="biologicNew"
          @entry-created="biologicCreated"
          modelNameSingular="Biologico"
          :useModelInsteadOfButton="true"
        /> -->


      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="my-2" @click="cancelAction">
          Cancelar
        </v-btn>

        <!-- <v-btn color="success" class="my-2" @click="cancelAction">
          Confirmar
          <v-icon right dark>mdi-check</v-icon>
        </v-btn> -->
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            v-on="{ ...tooltip, ...dialog }"
            class="mx-1"
            @click="openAction"
            :disabled="openSelectButtonDisabled">
          >
            {{addButtonIcon}}
          </v-icon>
        </template>
        <span>Adicionar Item</span>
      </v-tooltip>
    </template>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag';
import PartNew from "@models/items/parts/new.vue"
import OilNew from "@models/items/oils/new.vue"
import OtherNew from "@models/items/others/new.vue"
import AgrotoxicNew from "@models/items/agrotoxics/new.vue"
import FertilizerNew from "@models/items/fertilizers/new.vue"
import BiologicNew from "@models/items/biologicals/new.vue"

export default {
  data() {
    return {
      selectDialog: false,
      list: [],
      loading: false,
      pageLoading: false,
      formErrors: [],
      selectedObject: {},
      selected: 2,
    };
  },
  components: {
    PartNew: PartNew,
    OilNew: OilNew,
    OtherNew: OtherNew,
    AgrotoxicNew: AgrotoxicNew,
    FertilizerNew: FertilizerNew,
    BiologicNew: BiologicNew,
  },
  props: {
    idSelectedItem: {
      type: String
    },
    dialog: {
      type: Boolean,
      default: true
    },
    openSelectButtonDisabled: {
      type: Boolean,
      default: false
    },
    // formErrors: {
    //   type: Array,
    //   default: () => []
    // },
    isScrollable: {
      type: Boolean,
      default: true
    },
    // inlineAddButton: {
    //   type: Boolean,
    //   default: false
    // },
    addButtonIcon: {
      type: String,
      default: "mdi-plus"
    },
    newTitle: {
      type: String,
      default: "Seleção"
    },
    openSelectButtonLabel: {
      type: String,
      default: "Selecionar"
    },
    // newCancelButtonLabel: {
    //   type: String,
    //   default: "Cancelar"
    // },
    // newSaveButtonLabel: {
    //   type: String,
    //   default: "Salvar"
    // },
    // loading: {
    //   type: Boolean,
    //   default: true
    // },
    // pageLoading: {
    //   type: Boolean,
    //   default: false
    // }
  },
  methods: {
    partOpenAction: function() {
      if (this.$refs.partNew) {
        if (this.$refs.partNew.$refs.baseNew) {
          this.emitOpenActionPartNew();
          this.closeDialog();
        }
      }
    },
    oilOpenAction: function() {
      if (this.$refs.oilNew) {
        if (this.$refs.oilNew.$refs.baseNew) {
          this.emitOpenActionOilNew();
          this.closeDialog();
        }
      }
    },
    otherOpenAction: function() {
      if (this.$refs.otherNew) {
        if (this.$refs.otherNew.$refs.baseNew) {
          this.emitOpenActionOtherNew();
          this.closeDialog();
        }
      }
    },
    agrotoxicOpenAction: function() {
      if (this.$refs.agrotoxicNew) {
        if (this.$refs.agrotoxicNew.$refs.baseNew) {
          this.emitOpenActionAgrotoxicNew();
          this.closeDialog();
        }
      }
    },
    fertilizerOpenAction: function() {
      if (this.$refs.fertilizerNew) {
        if (this.$refs.fertilizerNew.$refs.baseNew) {
          this.emitOpenActionFertilizerNew();
          this.closeDialog();
        }
      }
    },
    biologicOpenAction: function() {
      if (this.$refs.biologicNew) {
        if (this.$refs.biologicNew.$refs.baseNew) {
          this.emitOpenActionBiologicNew();
          this.closeDialog();
        }
      }
    },
    emitOpenActionPartNew: function() {
      this.$refs.partNew.$refs.baseNew.openAction();
    },
    emitOpenActionOilNew: function() {
      this.$refs.oilNew.$refs.baseNew.openAction();
    },
    emitOpenActionOtherNew: function() {
      this.$refs.otherNew.$refs.baseNew.openAction();
    },
    emitOpenActionAgrotoxicNew: function() {
      this.$refs.agrotoxicNew.$refs.baseNew.openAction();
    },
    emitOpenActionFertilizerNew: function() {
      this.$refs.fertilizerNew.$refs.baseNew.openAction();
    },
    emitOpenActionBiologicNew: function() {
      this.$refs.biologicNew.$refs.baseNew.openAction();
    },
    cancelAction: function(){
      this.closeDialog();
      this.$emit("new-cancel-action")
    },
    selectAction: function(){
      this.$emit("select-action", this.selectedObject)
    },
    openAction: function() {
      this.selectDialog = true;
      // this.loadServerList();
      // this.$emit("new-open-action")
    },
    closeDialog: function() {
      this.selectDialog = false;
    },
    partCreated: function(part) {
      // console.log("part created on item select", part)
      this.itemCreated(part);
    },
    oilCreated: function(oil) {
      // console.log("oil created on item select", oil)
      this.itemCreated(oil);
    },
    otherCreated: function(other) {
      // console.log("other created on item select", other)
      this.itemCreated(other);
    },
    agrotoxicCreated: function(agrotoxic) {
      // console.log("part created on item select", part)
      this.itemCreated(agrotoxic);
    },
    fertilizerCreated: function(fertilizer) {
      // console.log("fertilizer created on item select", fertilizer)
      this.itemCreated(fertilizer);
    },
    biologicCreated: function(biologic) {
      // console.log("biologic created on item select", biologic)
      this.itemCreated(biologic);
    },
    itemCreated: function(item) {
      this.$emit("entry-created", item)
      this.selectDialog = false;
    }
  },
};

</script>

<style scoped></style>
